import { JSEncrypt } from 'jsencrypt';
import { useContext, useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { GlobalContext } from '../../context/GlobalContext';

import { getAccountByNumber, initiateOTP, cemInitiateOTP } from '../../api/api';

import ErrorModal from '../ErrorModal/ErrorModal';
import DeviceOTP from '../common/DeviceOTP/DeviceOTP';
import { delete_cookie } from '../../Utils/deleteCookies';
import DeviceClaim from '../common/DeviceClaim/DeviceClaim';
import DeviceTerms from '../common/DeviceTerms/DeviceTerms';
import DeviceLogin from '../common/DeviceLogin/DeviceLogin';
import SubsidySuccess from '../common/SubsidySuccess/SubsidySuccess';
import SubsidyErrorModal from '../common/SubsidyErrorModal/SubsidyErrorModal';

import './Subsidy.scss';

const win: any = window;
const serverURL = win['base_portal_url'];
const errorPage = win['errorPageURL'];

function Subsidy() {
    const { state, dispatch }: any = useContext(GlobalContext);
    const { subPageToDisplay, rtl, cartId, productData, deviceFlow } = state;
    const { preOrder } = productData;
    const { t } = useTranslation();

    const [headerCancel, setHeaderCancel] = useState(false);
    // const [notCustomer, setNotCustomer] = useState(false);
    const [timer, setTimer] = useState(0);

    const childRef: any = useRef();

    const handleSubmit = (number: string, userID: string) => {
        const lang = rtl ? 'ar' : 'en';
        cemCallInitiateOTPApi(number, userID, lang)
        // const msisdn = number.length > 0 ? number.replace('0', '966') : '';
        // getAccountByNumberApi(msisdn);
        dispatch({ type: "LOADER", payload: { loading: true } });
    }

    // const getAccountByNumberApi = (msisdn: string) => {
    //     getAccountByNumber(msisdn, preOrder)
    //         .then((res: any) => {
    //             if (res.status === 200 && res.data) {
    //                 if (res.data?.MSISDN) {
    //                     // callInitiateOTPApi(msisdn);
    //                     dispatch({ type: 'CUSTOMER_ACCOUNT_BY_NUMBER', payload: { customerAccount: res?.data } })
    //                 } else {
    //                     setNotCustomer(true);
    //                     dispatch({ type: "LOADER", payload: { loading: false } });
    //                 }
    //             } else {
    //                 window.location.href = serverURL + errorPage + `?errorSource= ${t("ecommerce")}`;
    //             }
    //         }).catch(err => {
    //             window.location.href = serverURL + errorPage + `?errorSource= ${t("ecommerce")}`;
    //         })
    // }

    // const callInitiateOTPApi = (msisdn: string) => {
    //     const current = new Date();
    //     const publicKey = win['public_key'];
    //     const jsencrypt = new JSEncrypt();
    //     jsencrypt.setPublicKey(publicKey);

    //     const mobileNumber = jsencrypt.encrypt(msisdn);

    //     const req: any = {
    //         msisdn: mobileNumber,
    //         FECEncrypted: 1,
    //         OTPType: 'Mobily',
    //         lang: rtl ? 'Ar' : 'en',
    //         cartId,
    //         currentDate: current.toISOString(),
    //         orderType: deviceFlow === 'subsidy' ? 'Device Subsidy' : 'Device Installment',
    //         customerName: '',
    //         deviceName: rtl ? productData.name.valueAr : productData.name.valueEn
    //     }

    //     initiateOTP(req, preOrder)
    //         .then((res: any) => {
    //             if (res.status === 200 && res.data) {
    //                 if (res?.data?.Status) {
    //                     setTimer(res.data?.OTPExpiry ? res.data?.OTPExpiry : 120);
    //                     dispatch({ type: "LOADER", payload: { loading: false } });
    //                     dispatch({ type: 'INITATE_OTP_DATA', payload: { OTPData: res?.data } });
    //                     dispatch({ type: 'SUB_PAGE_TO_DISPLAY', payload: { subPageToDisplay: 'deviceOTP' } });
    //                     dispatch({ type: 'DEVICE_MOBILENUMBER', payload: { msisdn: msisdn.replace('966', '0'), encryptedMSISDN: mobileNumber } });
    //                 }
    //             } else {
    //                 window.location.href = serverURL + errorPage + `?errorSource= ${t("ecommerce")}`;
    //             }
    //         }).catch(err => {
    //             window.location.href = serverURL + errorPage + `?errorSource= ${t("ecommerce")}`;
    //         })
    // }

    const cemCallInitiateOTPApi = (msisdn: any, userID: any, lang: any) => {
        // const publicKey = win['public_key'];
        const cemPublicKey = win['cem_public_key'];
        const jsencrypt = new JSEncrypt();
        jsencrypt.setPublicKey(cemPublicKey);

        const msisdnVal = msisdn.length > 0 ? msisdn.replace('0', '966') : '';
        const mobileNumber = jsencrypt.encrypt(msisdnVal);
        const idNumber = jsencrypt.encrypt(userID);

        cemInitiateOTP(mobileNumber, idNumber, lang)
            .then((res: any) => {
                if (res.status === 200 && res.data) {
                    if (res?.data?.status?.sourceCode === 'MAPI-000') {
                        setTimer(120);
                        dispatch({ type: "LOADER", payload: { loading: false } });
                        dispatch({ type: 'INITATE_OTP_DATA', payload: { OTPData: res?.data } });
                        dispatch({ type: 'SUB_PAGE_TO_DISPLAY', payload: { subPageToDisplay: 'deviceOTP' } });
                        dispatch({ type: 'DEVICE_MOBILENUMBER', payload: { msisdn: msisdn.replace('966', '0'), encryptedMSISDN: mobileNumber } });
                    } else {
                        window.location.href = serverURL + errorPage + `?errorSource= ${t("ecommerce")}`;
                    }
                } else {
                    window.location.href = serverURL + errorPage + `?errorSource= ${t("ecommerce")}`;
                }
            }).catch(err => {
                window.location.href = serverURL + errorPage + `?errorSource= ${t("ecommerce")}`;
            })
    }

    const handleHeaderCancel = () => {
        setHeaderCancel(true);
    }

    const handleModalContinue = () => {
        setHeaderCancel(false);
    }

    const handleModalDiscard = () => {
        setHeaderCancel(false);
        delete_cookie('device-scId');
        delete_cookie('device-xCoId');
        delete_cookie('device-count');
        delete_cookie('device-poid');
        delete_cookie('device-journeyName');
        document.body.style.overflow = 'auto';
        const wcmElement: any = document.getElementById("reactWCMControlBlockID");
        if (wcmElement !== null) {
            wcmElement.style.display = 'block';
        }
        dispatch({ type: 'PAGE_TO_DISPLAY', payload: { pageToDisplay: 'ProductDetails' } });
        dispatch({ type: 'SUB_PAGE_TO_DISPLAY', payload: { subPageToDisplay: 'deviceLogin' } });
    }

    // const handleNotCustomer = () => {
    //     setNotCustomer(false);
    //     childRef?.current?.removeMobileNumber();
    // }

    return (
        <div className='SubsidyFlow__Container container'>
            {subPageToDisplay === 'deviceLogin' && (
                <DeviceLogin
                    ref={childRef}
                    handleSubmit={handleSubmit}
                    handleHeaderCancel={handleHeaderCancel}
                />
            )}
            {subPageToDisplay === 'deviceOTP' && (
                <DeviceOTP
                    timer={timer}
                    setTimer={setTimer}
                    handleHeaderCancel={handleHeaderCancel}
                />
            )}
            {subPageToDisplay === 'deviceClaimPlan' && (
                <DeviceClaim
                    handleHeaderCancel={handleHeaderCancel}
                />
            )}
            {subPageToDisplay === 'deviceTermsNCondition' && (
                <DeviceTerms
                    handleHeaderCancel={handleHeaderCancel}
                />
            )}
            {subPageToDisplay === 'deviceSubsidySuccess' && (
                <SubsidySuccess />
            )}

            {headerCancel && (
                <SubsidyErrorModal
                    id='duplicate-shopping-cartId'
                    title={deviceFlow === 'subsidy' ? t('Cancel_subsidy') : t('discard_installment_title')}
                    description={deviceFlow === 'subsidy' ? t('Info_lost_go_back') : t('go_back_installment_information_lost')}
                    firstButtonText={deviceFlow === 'subsidy' ? t('Continue_Subsidy') : t('continue_with_installment')}
                    secButtonText={deviceFlow === 'subsidy' ? t('Cancel_subsidy_btn') : t('discard_installment_button')}
                    modalFirstButtonClick={handleModalContinue}
                    modalSecondButtonClick={handleModalDiscard}
                />
            )}

            {/* {notCustomer && (
                <ErrorModal
                    id={'not-a-mobily-number'}
                    rtl={rtl}
                    title={t('Not_a_mobily_number')}
                    description={t('we_didnot_recognize_number')}
                    firstButtonText={t('Got_it')}
                    modalFirstButtonClick={handleNotCustomer}
                />
            )} */}
        </div>
    )
}

export default Subsidy;
